<template>
  <div class="in_out" :class="more ? 'more_in' : ''">
    <div v-if="!more" class="data-list">
      <ul v-if="dynamicsData.length > 0">
        <li v-for="(item, index) in dynamicsData" :key="index">
          <span class="li_icon"></span>
          <el-tooltip effect="dark" :content="item.content" placement="top-end">
            <span>
              {{ item.userName }}-{{ item.helmetId }}-<span class="alarm_event">{{ item.chargeState }}</span>-{{item.logTimestamp}}
            </span>
          </el-tooltip>
        </li>
      </ul>
      <div v-else class="empty">{{ $t('NoEquipmentPowerData') }}</div>
    </div>
    <div v-if="more" class="more_table common-blue-contain">
      <div class="time"><SearchDate @handleSearch="handleSearch" :searchDate="historyParam"></SearchDate></div>
      <!-- 设备剩余电量 查看更多table-->
      <el-table :data="dynamicsData" style="width: 100%" v-if="moreTitle === $t('RemainingPowerEquipment')">
        <el-table-column type="index" :index="indexMethod" :label="$t('SerialNo')" width="100" align="center">
        </el-table-column>
        <el-table-column prop="userName" :label="$t('userNameH')"> </el-table-column>
        <el-table-column prop="helmetId" :label="$t('serialNumberP')"> </el-table-column>
        <el-table-column prop="chargeState" :label="$t('RemainingElectricity')"> </el-table-column>
        <el-table-column prop="logTimestamp" :label="$t('time')"> </el-table-column>
      </el-table>
      <!-- 设备状态告警更多table -->
      <el-table :data="healthyData" style="width: 100%" v-if="moreTitle === $t('EquipmentStatusAlarm')">
        <el-table-column prop="userName" :label="$t('userNameH')"> </el-table-column>
        <el-table-column prop="helmetId" :label="$t('serialNumberP')"> </el-table-column>
        <el-table-column prop="event" :label="$t('eventH')"> </el-table-column>
        <el-table-column prop="logTimestamp" :label="$t('time')"> </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="historyParam.currentPage"
        :page-size="historyParam.pageSize"
        layout="total, prev, pager, next"
        :total="historyParam.allPage"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { healthStatus, batterysStatus } from '@/api/new-device/newDevice'
import { nowTime, formatDate, beforeMonthTime } from '@/util/date'
import SearchDate from '@/views/new-home/SearchDate.vue'
export default {
  props: {
    more: {
      type: Boolean,
    },
    currenNode: {
      type: Object / Array,
    },
    moreTitle: {
      type: String,
    },
  },
  components: {
    SearchDate,
  },
  data() {
    return {
      // 设备动态信息展示
      dynamicsData: [],
      // 设备状态告警table数据
      healthyData: [],
      // 请求人员进出参数（电子围栏log)
      newNode: { id: '', startTime: '', endTime: '' },
      // 请求数据参数
      historyParam: {
        currentPage: 1,
        pageSize: 9,
        allPage: 0,
        startTime: beforeMonthTime(),
        endTime: nowTime(),
      },
      // 超长显示
      showTip: false,
    }
  },
  methods: {
    // 日期子组件触发 处理事件
    handleSearch(val) {
      this.historyParam.startTime = val.logTimestampBegin
      this.historyParam.endTime = val.logTimestampEnd
      this.historyParam.currentPage = 1
      if (this.moreTitle === this.$t('RemainingPowerEquipment')) {
        this.getCatterysStatus()
      } else {
        this.gethealthStatus()
      }
    },
    handleSizeChange(val) {
      this.historyParam.pageSize = val
      if (this.moreTitle === this.$t('RemainingPowerEquipment')) {
        this.getCatterysStatus()
      } else {
        this.gethealthStatus()
      }
    },
    handleCurrentChange(val) {
      this.historyParam.currentPage = val
      if (this.moreTitle === this.$t('RemainingPowerEquipment')) {
        this.getCatterysStatus()
      } else {
        this.gethealthStatus()
      }
    },
    // 设备剩余电量
    getCatterysStatus() {
      let param = {
        ouId: this.newNode.id,
        logDateBegin: formatDate(this.historyParam.startTime),
        logDateEnd: formatDate(this.historyParam.endTime),
        pageSize: this.historyParam.pageSize,
        pageNum: this.historyParam.currentPage,
      }
      batterysStatus(param).then(res => {
        if (res.state === 0) {
          this.dynamicsData = []
          for (let item of res.value.content) {
            item.chargeState = this.$t('RemainingElectricity') + item.chargeState + '%'
            item.content = item.userName + item.helmetId + item.chargeState + item.logTimestamp
            this.dynamicsData.push(item)
          }
          this.historyParam.allPage = res.value.totalElements
          // 根据返回数据的条数 触发返回是否显示查看更多
          if (this.historyParam.allPage > 6) {
            this.$emit('deviceBtnShow', true)
          } else {
            this.$emit('deviceBtnShow', false)
          }
        }
      })
    },
    indexMethod(index) {
      return index + 1
    },
    // 设备动态信展示
    // 设备状态分析
    gethealthStatus() {
      let param = {
        ouId: this.newNode.id,
        logDateBegin: formatDate(this.historyParam.startTime),
        logDateEnd: formatDate(this.historyParam.endTime),
        pageSize: this.historyParam.pageSize,
        pageNum: this.historyParam.currentPage,
      }
      healthStatus(param).then(res => {
        if (res.state === 0) {
          this.healthyData = []
          for (let item of res.value.content) {
            // 根据相应的参数显示意思
            if (item.event === 0) {
              item.event = this.$t('CPUtemperatureexceed')
            } else if (item.event === 1) {
              item.event = this.$t('Remainingmemorybelow')
            } else if (item.event === 2) {
              item.event = this.$t('RemainingStorageLess')
            } else if (item.event === 3) {
              item.event = this.$t('remainingPowerLess')
            }  else if (item.event === 4) {
              item.event = this.$t('batteryTempLow') + (item.abnormalData ? (item.abnormalData + '℃') : '')
            } else if (item.event === 5) {
              item.event = this.$t('batteryTempHigh') + (item.abnormalData ? (item.abnormalData + '℃') : '')
            }
            this.healthyData.push(item)
          }
          this.historyParam.allPage = res.value.totalElements
        }
      })
    },
  },

  mounted() {
    // this.getCatterysStatus()
  },
  watch: {
    more: {
      immediate: true,
      handler(val) {
        // 当前是否为查看更多去请求数据
        if (this.more && this.moreTitle === this.$t('RemainingPowerEquipment')) {
          this.getCatterysStatus()
        } else if (this.more && this.moreTitle === this.$t('EquipmentStatusAlarm')) {
          this.gethealthStatus()
        }
      },
    },
    currenNode: {
      handler(val) {
        // 查询不同租户触发请求数据
        if (this.currenNode.id !== '') {
          this.newNode.id = this.currenNode.id
          this.getCatterysStatus(this.currenNode)
        }
      },
      deep: true,
    },
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.in_out
  width: 100%
  height: 100%
  margin: 0 auto
  ul
    height: 100%
    width: 100%
    overflow: auto
    margin-top 10px
    li
      width: 100%
      line-height 36px
      padding-left 20px
      cursor default!important
      white-space: nowrap;
      display: block;
      overflow: hidden;
      text-overflow: ellipsis
      .li_icon
        display inline-block
        width: 8px;/*no*/
        height: 8px;/*no*/
        background: #FF3F63
        margin-right: 10px
      .alarm_event
        color: #FF3F63
      .occur_time
        margin-left: 10px

  .empty
    font-size: 16px
    color: #0E8BFF
    text-align: center
    margin-top 20px
.more_in
  width: 98%
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  .select_date
    background: none
    box-shadow none
  .time
    margin: 10px 0
    width 480px
  .more_table
    width 98%
    height 100%
  ul
    margin-left 80px
    margin-bottom: 20px
    li
      line-height 34px
  .pagination
    margin-top 10px
>>> .el-table
  height 85% !important
  min-height: 60% !important
  overflow: auto
>>> .el-table__body-wrapper
  overflow: auto
>>> .el-pager li.active
  color #00E4FF
</style>
